<template>
  <span class="rf-icon" aria-hidden="true">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
      <g clip-path="url(#rf-roku-icon-a)">
        <mask
          id="rf-roku-icon-b"
          width="28"
          height="14"
          x="-2"
          y="5"
          maskUnits="userSpaceOnUse"
          style="mask-type: luminance"
        >
          <path fill="white" stroke="none" d="M-1.6 18.2h27.2V5.4H-1.6z" />
        </mask>
        <g fill="inherit" stroke="none" mask="url(#rf-roku-icon-b)">
          <path
            d="M4.47 10.4c0-.62-.5-1.12-1.11-1.12H2.8v2.24h.56c.61 0 1.11-.5 1.11-1.11M7 14.89H4.96l-1.61-2.24H2.8v2.24H1.01V8.16h2.57c1.48 0 2.68 1 2.68 2.25 0 .75-.46 1.43-1.16 1.84z"
          />
          <path
            d="M9.01 10.8c-.47 0-.87.65-.87 1.45s.4 1.44.87 1.44c.49 0 .89-.65.89-1.44 0-.8-.4-1.44-.89-1.44m2.76 1.45A2.74 2.74 0 0 1 9 14.99a2.74 2.74 0 1 1 0-5.48 2.74 2.74 0 0 1 2.76 2.74M15.97 9.62l-2.06 2.07V9.62h-1.8v5.26h1.8v-2.14l2.15 2.14h2.26l-2.74-2.74 2.27-2.27V13c0 1.04.62 2 2.19 2 .75 0 1.43-.43 1.76-.8l.8.69H23V9.62h-1.8v3.4c-.2.36-.47.58-.9.58-.45 0-.65-.26-.65-1.1V9.62z"
          />
        </g>
      </g>
      <defs>
        <clipPath id="rf-roku-icon-a">
          <path fill="white" stroke="none" d="M0 0h22v6.85H0z" transform="translate(1 8.15)" />
        </clipPath>
      </defs>
    </svg>
  </span>
</template>
